import { AnchorButton, Button, ControlGroup, H4, HTMLSelect, InputGroup, Tab, Tabs } from "@blueprintjs/core";
import { DateRange, DateRangeInput } from "@blueprintjs/datetime";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
import { Users } from "@just-in-types";
import { format, parse } from "date-fns";
import { validate } from "isemail";
import { parse  as parseCsv } from "json2csv";
import * as React from "react";
import SitePicker, { ConnectedSitePicker, Selected } from "../components/SitePicker";
import firebase from "../firebase";
import { firestore } from "../firebase";
import "../styles/styles.css";

interface IReportsState {
  businessId: null | string;
  bigData: boolean;
  bigDataGetting: boolean;
  csv: null | string;
  email: null | string;
  endDate?: Date;
  getting: boolean;
  gettingError: boolean;
  gettingTheft: boolean;
  gettingVehiclePicks: boolean;
  occurence: null | string;
  scheduleType: null | string;
  scheduledReportRegistered: boolean;
  sendingScheduledReport: boolean;
  siteId: null | string;
  startDate?: Date;
  theftCsv: null | string;
  vehiclePicksCsv: null | string;
  voidCsv: null | string;
}

class Reports extends React.Component<{}, IReportsState> {
  public state = {
    businessId: null,
    bigData: false,
    bigDataGetting: false,
    csv: null,
    email: null,
    endDate: undefined,
    getting: false,
    gettingError: false,
    gettingTheft: false,
    gettingVehiclePicks: false,
    occurence: "weekly",
    scheduleType: "vehicle-picks",
    scheduledReportRegistered: false,
    sendingScheduledReport: false,
    siteId: null,
    startDate: undefined,
    theftCsv: null,
    vehiclePicksCsv: null,
    voidCsv: null,
  };
  public sitePicker: null | ConnectedSitePicker = null;

  public getVehiclePicksReport = async ({ businessId, endDate, siteId, startDate }) => {
    const data = {
      businessId,
      endDate: endDate ? endDate.toString() : null,
      siteId: siteId === "all" ? null : siteId,
      startDate: startDate ? startDate.toString() : null,
    };

    if(this.convertDate(data.endDate) === this.convertDate(new Date())){
      data.endDate = new Date().toString();
    }
    this.setState({ gettingVehiclePicks: true });
    const getVehiclePicksReport = firebase.functions().httpsCallable("generateVehiclePicksReport");
    let result:any;
    if(data.siteId && data.siteId === "ogden"){
      // data.siteId = "TMrSaHl6j451pEWxY7nu";
      // const result1 = await getVehiclePicksReport(data);  
      
      // data.siteId = "6vVH4qpzsVxjmROhMDmh";
      // const result2 = await getVehiclePicksReport(data);  

      data.siteId = "1YYyeZ1YXjGyc6Z6vwRt";
      const result3 = await getVehiclePicksReport(data);  

      // let res1 = '';
      // let res2 = '';
      // let res3 = '';
      
      // let resHead = '';
      // let resHeadEnable = true;

      // if(result1.data && resHeadEnable){
      //   resHead = result1.data.split("%0A")[0];
      //   resHeadEnable = false;
      // }

      // if(result2.data && resHeadEnable){
      //   resHead = result2.data.split("%0A")[0];
      //   resHeadEnable = false;
      // }

      // if(result3.data && resHeadEnable){
      //   resHead = result3.data.split("%0A")[0];
      //   resHeadEnable = false;
      // }

      // if(result1.data){
      //   res1 = result1.data.substring(result1.data.indexOf('%0A'));
      // }

      // if(result2.data){
      //   res2 = result2.data.substring(result2.data.indexOf('%0A'));
      // }

      // if(result3.data){
      //   res3 = result3.data.substring(result3.data.indexOf('%0A'));
      // }

      // result = resHead + res1 + res2 + res3; 
      
      result = result3.data; 
      
      const vehiclePicksCsv = result;
      if (vehiclePicksCsv) {
        this.setState({ vehiclePicksCsv, gettingVehiclePicks: false });
      } else {
        this.handleGettingError();
      }

    }else if(data.siteId && data.siteId === "slc"){
      // data.siteId = "FDYHKAMSiYNCuXumk5Iv";
      // const result1 = await getVehiclePicksReport(data);  
      
      // data.siteId = "kv9ciglhFsJBh9YyV2sd";
      // const result2 = await getVehiclePicksReport(data);  

      data.siteId = "17VBJyeH2crmqQC2OSxx";
      const result3 = await getVehiclePicksReport(data);  

      // let res1 = '';
      // let res2 = '';
      // let res3 = '';
      
      // let resHead = '';
      // let resHeadEnable = true;

      // if(result1.data && resHeadEnable){
      //   resHead = result1.data.split("%0A")[0];
      //   resHeadEnable = false;
      // }

      // if(result2.data && resHeadEnable){
      //   resHead = result2.data.split("%0A")[0];
      //   resHeadEnable = false;
      // }

      // if(result3.data && resHeadEnable){
      //   resHead = result3.data.split("%0A")[0];
      //   resHeadEnable = false;
      // }

      // if(result1.data){
      //   res1 = result1.data.substring(result1.data.indexOf('%0A'));
      // }

      // if(result2.data){
      //   res2 = result2.data.substring(result2.data.indexOf('%0A'));
      // }

      // if(result3.data){
      //   res3 = result3.data.substring(result3.data.indexOf('%0A'));
      // }

      // result = resHead + res1 + res2 + res3; 

      result = result3.data; 
      
      const vehiclePicksCsv = result;
      if (vehiclePicksCsv) {
        this.setState({ vehiclePicksCsv, gettingVehiclePicks: false });
      } else {
        this.handleGettingError();
      }

    }else{
      result = await getVehiclePicksReport(data);
      // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjj");
      // console.log(result.data);
      const vehiclePicksCsv = result.data;
      if (vehiclePicksCsv) {
        this.setState({ vehiclePicksCsv, gettingVehiclePicks: false });
      } else {
        this.handleGettingError();
      }
    }
    // result = await getVehiclePicksReport(data);
    // console.log("jjjjjjjjjjjjjjjjjjjjjjjjjjj");
    // console.log(result.data.split("0A")[0]);
    // console.log(result.data.substring(result.data.indexOf('0A')));
    // const vehiclePicksCsv = result.data;
    // if (vehiclePicksCsv) {
    //   this.setState({ vehiclePicksCsv, gettingVehiclePicks: false });
    // } else {
    //   this.handleGettingError();
    // }
  };


  public convertDate= (str) => {
    const date = new Date(str);
    const   mnth = ("0" + (date.getMonth() + 1)).slice(-2);
    const   day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  public getTheftReport = async ({ businessId, endDate, siteId, startDate }) => {
    const data = {
      businessId,
      endDate: endDate ? endDate.toString() : null,
      siteId: siteId === "all" ? null : siteId,
      startDate: startDate ? startDate.toString() : null,
    };

    this.setState({ gettingTheft: true });
    const getTheftReport = firebase.functions().httpsCallable("generateTheftReport");
    const result = await getTheftReport(data);
    const theftCsv = result.data;
    if (theftCsv) {
      this.setState({ theftCsv, gettingTheft: false });
    } else {
      this.handleGettingError();
    }
  };


  public getBigDataReport = async()=>{
    console.log("GETTING Large Data");
    const { businessId, endDate, siteId, startDate } = this.state;
    this.setState({ bigDataGetting: true, bigData:false });
    try {


      let sId : any = siteId;

      if(siteId && siteId === 'ogden'){
        sId = "6vVH4qpzsVxjmROhMDmh";
      }

      if(siteId && siteId === 'slc'){
        sId = "kv9ciglhFsJBh9YyV2sd";
      }

      if (businessId) {
        const query = this.generateBigQuery({
          businessId,
          endDate,
          siteId: sId === "all" ? null : sId,
          startDate,
        });

        const checkIns = await this.getBigCheckIns(query);
        if(checkIns && checkIns.length >= 80000){
          this.setState({ bigDataGetting: false, bigData:true });
          return;
        }
        const processed = this.processBigCheckIns(checkIns);
        
        const doc = await firestore
        .collection(`businesses`)
        .doc(businessId)
        .get();

        const businessData: any = doc.data();

        if(businessData.sensitiveDataMaskingSwitch){
          processed.forEach((ele, i)=>{
            if(ele.mobile !== "opted out"){
              processed[i].mobile = this.maskNumber(ele.mobile);
            }
          });
        }

        console.log("GETTING TOTALS all");
        const checkInsTotal = checkIns?checkIns.length:0;
        
        const optOutsTotal = await this.getOptOutsTotal(query);
        // const checkInsQuery = await query.get();
        // const checkInsTotal = checkInsQuery.size;

        const voidedTotal = await this.getVoidedTotal(businessId, endDate, sId, startDate);

        if(processed.length > 0) {
          processed[0].totals = "Check Ins Count: " + checkInsTotal;
          processed[1].totals = "Kiosk Opt Outs Count: " + optOutsTotal;
          processed[2].totals = "Void Count: " + voidedTotal;
        }

        const csv =
          processed.length > 0
            ? parseCsv(processed, {
                fields: this.generateBigFieldsArray(businessId),
              })
            : null;
      
        if (csv) {
          this.setState({ csv, bigDataGetting: false, bigData:false });
        } else {
          this.handleGettingError();
        }
      
      }
    } catch (error) {
      console.log("ERROR");
      console.log(error);
      this.setState({ bigDataGetting: false, bigData:true });
    }

  }

  public processBigCheckIns = (checkIns: Users.CheckIn[]) =>
  checkIns.map(
    ({
      businessPath,
      checkInId,
      language,
      mobile,
      mugshotUrl,
      name,
      secretMobile,
      signatureUrl,
      sitePath,
      supercard,
      timestamp,
      userId,
      vehicles,
      zip,
    }) => ({
      checkInId,
      firstname: (name && name.firstname) || null,
      language,
      lastname: (name && name.lastname) || null,
      location: sitePath,
      mobile: secretMobile || this.processMobile(mobile),
      picture: mugshotUrl,
      signature: signatureUrl,
      supercard: supercard ? supercard : "",
      timestamp: this.convertTimestamp(timestamp),
      totals: "",
      userId,
      vehicles,
      zip,
    })
  );


  public generateBigFieldsArray = (businessId: string) => {
    const fields = [
      { label: "Date/Time", value: "timestamp" },
      { label: "Location", value: "location" },
      { label: "Language", value: "language" },
      { label: "Mobile", value: "mobile" },
      { label: "Email", value: "email" },
      { label: "First Name", value: "firstname" },
      { label: "Last Name", value: "lastname" },
      { label: "ZIP Code", value: "zip" },
      {
        label: "Fresh Stock Notification Picks",
        value: (row: any) => (row.vehicles ? this.processVehicles(row.vehicles) : " "),
      },
      { label: "Totals", value: "totals" },
    ];
  
    // if business is ACE, we need to add a row for Supercard to their report
    if (businessId === "lePLUdje4NIuHLUiWuow") {
      fields.splice(8, 0, { label: "Supercard", value: "supercard" });
    }
  
    return fields;
  };

  public processVehicles = (vehicles: Users.VehiclePick[]) => {
    let str = "";
    vehicles.forEach((vehicle, index, arr) => {
      let formatted =
        vehicle.yearMin +
        "-" +
        vehicle.yearMax +
        " " +
        vehicle.make +
        " " +
        vehicle.model;
  
      if (index !== arr.length - 1) {
        formatted += ", ";
      }
  
      str += formatted;
    });
    return str;
  };

  public getVoidedTotal = async (businessId, endDate, siteId, startDate) => {
    let query = firestore
      .collection("voidedCheckIns")
      .where("businessId", "==", businessId);
    if (siteId && siteId !== 'all') {
      query = query.where("siteId", "==", siteId);
    }
    if (startDate) {
      query = query.where("voidedAt", ">=", new Date(startDate));
    }
    if (endDate) {
      const end = new Date(endDate ? endDate : "");
      end.setDate(end.getDate() + 1);
      query = query.where("voidedAt", "<=", end);
    }
  
    const result = await query.get();
    return result.size;
  };
  

  public getOptOutsTotal = async (query: any) => {
    const result = await query.where("mobile", "==", "6028181729").get();
    return result.size;
  };

  public getBigCheckIns = async (query: any) => {
    try {
      const snapshot = await query.orderBy("timestamp", "desc").get();
      const checkIns: any = [];
  
      snapshot.forEach((doc) => {
        if (doc.exists) {
          const checkInId = doc.id;
          const checkInData = doc.data() as any;
  
          checkIns.push({ ...checkInData, checkInId });
        }
      });
  
      return checkIns;
    } catch (error) {
      console.log(error, "error");
      // this.setState({ bigDataGetting: false, bigData:true });
    }
  };

  public maskNumber = (num: any) => {
    const x = num.toString().match(/(\d{3})(\d{3})(\d{4})/);
    return "(" + x[1] + ")" + " *** " + x[3];
  };
  

  public generateBigQuery = ({
    businessId,
    endDate,
    siteId,
    startDate,
  }: {
    businessId?: string;
    endDate?: string;
    siteId?: string | null;
    startDate?: string;
  }) => {
    const ref = firestore.collection("checkIns");
    const end = new Date(endDate ? endDate : "");
    end.setDate(end.getDate() + 1);
    let query: any = ref;
  
    if (businessId) {
      query = query.where("businessId", "==", businessId);
    }
  
    if (siteId) {
      query = query.where("siteId", "==", siteId);
    }
  
    if (startDate) {
      query = query.where("timestamp", ">=", new Date(startDate));
    }
  
    if (endDate) {
      query = query.where("timestamp", "<=", end);
    }
  
    return query;
  };
  
  public getReport = async ({ businessId, endDate, siteId, startDate }: Partial<IReportsState>) => {
    console.log("Get Report");
    try {
      const data = {
        businessId,
        endDate: endDate ? endDate.toString() : null,
        siteId: siteId === "all" ? null : siteId,
        startDate: startDate ? startDate.toString() : null,
        // skipLargeQuery:true,
      };

      this.setState({ getting: true, bigData:false });

      const getCheckInsReport = firebase.functions().httpsCallable("generateCheckInsReport");


      // let result:any;

      if(data.siteId && data.siteId === 'ogden'){
        data.siteId = "6vVH4qpzsVxjmROhMDmh";
        const result = await getCheckInsReport(data);
        const csv = result.data;
  
        if (csv) {
          this.setState({ csv, getting: false });
        } else {
          this.handleGettingError();
        }
      }else if(data.siteId && data.siteId === 'slc'){
        data.siteId = "kv9ciglhFsJBh9YyV2sd";
        const result = await getCheckInsReport(data);
        const csv = result.data;
  
        if (csv) {
          this.setState({ csv, getting: false });
        } else {
          this.handleGettingError();
        }
      }else{
        const result = await getCheckInsReport(data);
        const csv = result.data;
  
        if (csv) {
          this.setState({ csv, getting: false });
        } else {
          this.handleGettingError();
        }
      }

      // result = await getCheckInsReport(data);
      // const csv = result.data;

      // if (csv) {
      //   this.setState({ csv, getting: false });
      // } else {
      //   this.handleGettingError();
      // }
    } catch (error) {
      console.error(error);

      this.handleGettingError();
    }
  };

  public getVoidReport = async ({ businessId, endDate, siteId, startDate }: Partial<IReportsState>) => {
    try {
      const data = {
        businessId,
        endDate: endDate ? endDate.toString() : null,
        siteId: siteId === "all" ? null : siteId,
        startDate: startDate ? startDate.toString() : null,
      };

      this.setState({ getting: true });


      if(data.siteId && data.siteId === 'ogden'){
        data.siteId = "6vVH4qpzsVxjmROhMDmh";

        const voidCsv = await this.generateVoidCheckInsReport(data);

        if (voidCsv) {
          this.setState({ voidCsv, getting: false });
        } else {
          this.handleGettingError();
        }

      }else if(data.siteId && data.siteId === 'slc'){
        data.siteId = "kv9ciglhFsJBh9YyV2sd";

        const voidCsv = await this.generateVoidCheckInsReport(data);

        if (voidCsv) {
          this.setState({ voidCsv, getting: false });
        } else {
          this.handleGettingError();
        }

      }else{
        const voidCsv = await this.generateVoidCheckInsReport(data);

        if (voidCsv) {
          this.setState({ voidCsv, getting: false });
        } else {
          this.handleGettingError();
        }
      }

      // const voidCsv = await this.generateVoidCheckInsReport(data);

      // if (voidCsv) {
      //   this.setState({ voidCsv, getting: false });
      // } else {
      //   this.handleGettingError();
      // }
    } catch (error) {
      console.error(error);

      this.handleGettingError();
    }
  };



  public handleSitePicker = ({ businessId, siteId }: Selected) =>
    this.setState({
      businessId,
      csv: null,
      siteId: siteId || null,
      vehiclePicksCsv: null,
      voidCsv: null,
    });

  public CheckinreportPanel = (getting, csv, getButtonDisabled, gettingError) => (
    <div id="chkinreoprtstyle">
      <H4>Check-Ins Report</H4>
      <div id="chkin-style">
        <ControlGroup>
          <SitePicker
            disabled={getting}
            filter={true}
            hasAll={true}
            onSelect={this.handleSitePicker}
            ref={(ref) => (this.sitePicker = ref)}
          />
          <DateRangeInput
            disabled={getting}
            formatDate={this.dateFormatter}
            onChange={this.handleDateRangeInput}
            parseDate={this.dateParser}
            allowSingleDayRange={true}
          />
          {csv ? (
            <AnchorButton
              download="export.csv"
              href={`data:text/csv;charset=utf-8,${csv}`}
              intent="success"
              rightIcon="download"
            >
              download csv
            </AnchorButton>
          ) : (
            <>
            <Button
              disabled={getButtonDisabled}
              intent={gettingError ? "danger" : "primary"}
              rightIcon={gettingError ? undefined : "globe-network"}
              loading={getting}
              onClick={this.handleGetReportButton}
            >
              {gettingError ? "no check-ins" : "get report"}
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button
              disabled={getButtonDisabled}
              intent={gettingError ? "danger" : "primary"}
              rightIcon={gettingError ? undefined : "globe-network"}
              loading={this.state.bigDataGetting}
              onClick={this.getBigDataReport}
              style={{ display:"none"}}
            >
              {gettingError ? "no check-ins" : "get Large report"}
            </Button>
            </>
          )}
        </ControlGroup>
      </div>
      
      {
        this.state.bigData?(
          <div style={{ backgroundColor: "red", color:"#fff", padding:"10px", width:"470px", fontSize:"15px", borderRadius:"5px" }}>
            Your output data is larger than expected. Please select lower range. 
        </div>
        ):
        (
          ""
        )
      }
    </div>
  );

  public VoidCheckinreportPanel = (getting, voidCsv, getButtonDisabled, gettingError) => (
    <div id="chkinreoprtstyle">
      <H4>Void Check-Ins Report</H4>
      <div id="void-chkin-style">
        <ControlGroup>
          <SitePicker
            disabled={getting}
            filter={true}
            hasAll={true}
            onSelect={this.handleSitePicker}
            ref={(ref) => (this.sitePicker = ref)}
          />
          <DateRangeInput
            disabled={getting}
            formatDate={this.dateFormatter}
            onChange={this.handleDateRangeInput}
            parseDate={this.dateParser}
            allowSingleDayRange={true}
          />
          {voidCsv ? (
            <AnchorButton
              download="export.csv"
              href={`data:text/csv;charset=utf-8,${voidCsv}`}
              intent="success"
              rightIcon="download"
            >
              download csv
            </AnchorButton>
          ) : (
            <Button
              disabled={getButtonDisabled}
              intent={gettingError ? "danger" : "primary"}
              rightIcon={gettingError ? undefined : "globe-network"}
              loading={getting}
              onClick={this.handleGetVoidReportButton}
            >
              {gettingError ? "no Void check-ins" : "get report"}
            </Button>
          )}
        </ControlGroup>
      </div>
    </div>
  );

  public GetReportPanel = (gettingVehiclePicks, email, occurenceSelect, scheduleReportText) => (
    <div>
      <H4>Get Reports delivered straight to your email! Sign up here:</H4>
      <div id="get-report-style">
        <ControlGroup>
          <SitePicker
            disabled={gettingVehiclePicks}
            filter={true}
            hasAll={true}
            onSelect={this.handleSitePicker}
            ref={(ref) => (this.sitePicker = ref)}
          />
        </ControlGroup>
        <br />
        <br />
        <br />
        <ControlGroup>
          <InputGroup
            intent={email !== null ? "none" : "danger"}
            onChange={this.handleEmailChange}
            placeholder="email"
          />
          <HTMLSelect onChange={this.handleScheduleTypeChange}>
            <option value="vehicle-picks">Vehicle Picks Report</option>
            <option value="check-ins">Check Ins Report</option>
          </HTMLSelect>
          {occurenceSelect}
          &nbsp;
          <Button
            intent="primary"
            rightIcon={this.state.scheduledReportRegistered ? "saved" : undefined}
            onClick={this.handeScheduleReportsButton}
          >
            {scheduleReportText}
          </Button>
        </ControlGroup>
      </div>
    </div>
  );
  public VehicleReportPanel = (gettingVehiclePicks, getting, vehiclePicksCsv, gettingError) => (
    <div>
      <H4>Vehicle Picks Report</H4>
      <div id="vehicle-report-style">
        <ControlGroup>
          <SitePicker
            disabled={gettingVehiclePicks}
            filter={true}
            hasAll={true}
            onSelect={this.handleSitePicker}
            ref={(ref) => (this.sitePicker = ref)}
          />
          <DateRangeInput
            disabled={getting}
            formatDate={this.dateFormatter}
            onChange={this.handleDateRangeInput}
            parseDate={this.dateParser}
            allowSingleDayRange={true}
          />
          {vehiclePicksCsv ? (
            <AnchorButton
              download="vehiclePicksReport.csv"
              href={`data:text/csv;charset=utf-8,${vehiclePicksCsv}`}
              intent="success"
              rightIcon="download"
            >
              download csv
            </AnchorButton>
          ) : (
            <Button
              disabled={false}
              intent={gettingError ? "danger" : "primary"}
              rightIcon={gettingError ? undefined : "globe-network"}
              loading={gettingVehiclePicks}
              onClick={this.handleGetVehiclePicksReportButton}
            >
              {gettingError ? "no check-ins" : "get report"}
            </Button>
          )}
        </ControlGroup>
      </div>
    </div>
  );

  public TheftReportPanel = (gettingTheft, getting, theftCsv, gettingError) => (
    <div>
      <H4>Theft Report</H4>
      <div id="vehicle-report-style">
        <ControlGroup>
          <SitePicker
            disabled={gettingTheft}
            filter={true}
            hasAll={true}
            onSelect={this.handleSitePicker}
            ref={(ref) => (this.sitePicker = ref)}
          />
          <DateRangeInput
            disabled={getting}
            formatDate={this.dateFormatter}
            onChange={this.handleDateRangeInput}
            parseDate={this.dateParser}
          />
          {theftCsv ? (
            <AnchorButton
              download="vehiclePicksReport.csv"
              href={`data:text/csv;charset=utf-8,${theftCsv}`}
              intent="success"
              rightIcon="download"
            >
              download csv
            </AnchorButton>
          ) : (
            <Button
              disabled={false}
              intent={gettingError ? "danger" : "primary"}
              rightIcon={gettingError ? undefined : "globe-network"}
              loading={gettingTheft}
              onClick={this.handleGetTheftReportButton}
            >
              {gettingError ? "no Theft" : "get report"}
            </Button>
          )}
        </ControlGroup>
      </div>
    </div>
  );

  public render() {
    const {
      businessId,
      csv,
      email,
      getting,
      gettingError,
      gettingVehiclePicks,
      scheduledReportRegistered,
      // scheduleType,
      sendingScheduledReport,
      siteId,
      vehiclePicksCsv,
      voidCsv,
    } = this.state;
    const getButtonDisabled = !businessId || gettingError || !siteId;
    let scheduleReportText = sendingScheduledReport ? " ... " : "Sign Up";
    if (scheduledReportRegistered) {
      scheduleReportText = "";
    }

    let occurenceSelect;
    // if (scheduleType === "check-ins") {
    //   occurenceSelect = (
    //     <HTMLSelect onChange={this.handleOccurenceChange}>
    //       <option value="weekly">Weekly (every Mon)</option>
    //       <option value="monthly">Monthly (every 1st)</option>
    //       <option value="daily">Daily</option>
    //     </HTMLSelect>
    //   );
    // } else {
    //   occurenceSelect = "";
    // }
    occurenceSelect = (
      <HTMLSelect onChange={this.handleOccurenceChange}>
        <option value="weekly">Weekly (every Mon)</option>
        <option value="monthly">Monthly (every 1st)</option>
        <option value="daily">Daily</option>
      </HTMLSelect>
    );

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "50px",
        }}
      >
        <div style={{ width: "1200px", flex: 2, padding: "20px" }}>
          <Tabs id="TabsExample" key={"horizontal"}>
            <Tab
              id="checkinreport"
              title="Check-Ins Report"
              panel={this.CheckinreportPanel(getting, csv, getButtonDisabled, gettingError)}
            />
            <Tab
              id="vehiclereport"
              title="Vehicle Picks Report"
              panel={this.VehicleReportPanel(gettingVehiclePicks, getting, vehiclePicksCsv, gettingError)}
            />
            <Tab
              id="getreport"
              title="Reports Delivered to Mail"
              panel={this.GetReportPanel(gettingVehiclePicks, email, occurenceSelect, scheduleReportText)}
            />
            <Tab
              id="voidcheckinreport"
              title="Void Check-Ins Report"
              panel={this.VoidCheckinreportPanel(getting, voidCsv, getButtonDisabled, gettingError)}
            />
            <Tabs.Expander />
          </Tabs>
        </div>
      </div>
    );
  }

  private handleGettingError = () => {
    this.setState({ getting: false, gettingError: true });

    setTimeout(() => {
      this.setState({ gettingError: false, gettingVehiclePicks: false });
    }, 2000);
  };

  private dateFormatter = (date: Date) => format(date, "MM[/]DD[/]YY");
  private dateParser = (dateString: string) => parse(dateString);

  private handleDateRangeInput = (range: DateRange) => {
    const startDate = range[0];
    const endDate = range[1];

    this.setState({ csv: null, voidCsv : null, startDate, endDate });
  };

  private handleGetReportButton = () => {
    const { businessId, endDate, siteId, startDate } = this.state;

    this.getReport({ businessId, endDate, siteId, startDate });
  };
  private handleGetVoidReportButton = () => {
    const { businessId, endDate, siteId, startDate } = this.state;

    this.getVoidReport({ businessId, endDate, siteId, startDate });
  };
  private handleGetVehiclePicksReportButton = () => {
    const { businessId, endDate, siteId, startDate } = this.state;

    this.getVehiclePicksReport({ businessId, endDate, siteId, startDate });
  };

  private handleGetTheftReportButton = () => {
    const { businessId, endDate, siteId, startDate } = this.state;

    this.getTheftReport({ businessId, endDate, siteId, startDate });
  };

  private handleEmailChange = (event) => {
    const email = event.currentTarget.value;
    this.setState({ email });
  };
  private handleOccurenceChange = (event) => {
    const occurence = event.currentTarget.value;
    this.setState({ occurence });
  };
  private handleScheduleTypeChange = (event) => {
    const type = event.currentTarget.value;
    this.setState({ scheduleType: type });
  };

  private handeScheduleReportsButton = async () => {
    const { businessId, siteId, email, occurence, scheduleType } = this.state;
    if (email && !validate(email)) {
      console.log("invalid");
    } else {
      this.setState({ sendingScheduledReport: true });
      const data = {
        businessId,
        email,
        occurence,
        siteId,
        type: scheduleType,
      };
      console.log(data);
      const addScheduledReport = firebase.functions().httpsCallable("addScheduledReport");
      const result = await addScheduledReport(data);
      this.setState({
        scheduledReportRegistered: true,
        sendingScheduledReport: false,
      });
      console.log(result);
    }
  };



  private generateQuery = ({
    businessId,
    endDate,
    siteId,
    startDate,
  }: {
    businessId?: string;
    endDate?: string;
    siteId?: string;
    startDate?: string;
  }) => {
    const ref = firestore.collection("voidedCheckIns");
    const end = new Date(endDate ? endDate : "");
    end.setDate(end.getDate() + 1);
    let query: any = ref;
  
    if (businessId) {
      query = query.where("businessId", "==", businessId);
    }
  
    if (siteId) {
      query = query.where("siteId", "==", siteId);
    }
  
    if (startDate) {
      query = query.where("voidedAt", ">=", new Date(startDate));
    }
  
    if (endDate) {
      query = query.where("voidedAt", "<=", end);
    }
  
    return query;
  };



  private getCheckIns = async (query: any) => {
      // const snapshot = await query.orderBy("voidedAt", "desc").get();
      const snapshot = await query.get();
      const checkIns: any = [];
      let checkInsRev: any = [];
  
      await snapshot.forEach((doc) => {
        if (doc.exists) {
          const checkInId = doc.id;
          const checkInData = doc.data();
  
          checkIns.push({ ...checkInData, checkInId });
        }
      });

      checkInsRev = checkIns.reverse();
  
      return checkInsRev;
  };
  
  private processCheckIns = (checkIns: any) =>
  checkIns.map(
    ({
      businessPath,
      checkInId,
      language,
      mobile,
      mugshotUrl,
      name,
      secretMobile,
      signatureUrl,
      sitePath,
      supercard,
      timestamp,
      userId,
      vehicles,
      voidedAt,
      zip,
    }) => ({
      checkInId,
      firstname: (name && name.firstname) || null,
      language,
      lastname: (name && name.lastname) || null,
      location: sitePath,
      mobile: secretMobile || this.processMobile(mobile),
      picture: mugshotUrl,
      signature: signatureUrl,
      supercard: supercard ? supercard : "",
      timestamp: this.convertTimestamp(timestamp),
      // totals: "",
      userId,
      vehicles,
      voidedAt: this.convertTimestamp(voidedAt),
      zip,
    })
  );


  private processMobile = (mobile: string | null) => {
    if (mobile) {
      if (mobile === "6028181729") {
        return "opted out";
      }
      return mobile;
    }
    return null;
  };
  
  private convertTimestamp = (timestamp: any) => {
    const date = timestamp.toDate();
    const formatted = date.toLocaleString("en-US", {
      timeZone: "America/Chicago",
      timeZoneName: "short",
    });
  
    return formatted;
  };
  
  private generateFieldsArray = (businessId) => {
    const fields = [
      { label: "Date/Time", value: "timestamp" },
      { label: "Location", value: "location" },
      { label: "Language", value: "language" },
      { label: "Mobile", value: "mobile" },
      { label: "Email", value: "email" },
      { label: "First Name", value: "firstname" },
      { label: "Last Name", value: "lastname" },
      { label: "ZIP Code", value: "zip" },
      { label: "Void At", value: "voidedAt" },
      // {
      //   label: "Fresh Stock Notification Picks",
      //   value: (row: any) => (row.vehicles ? processVehicles(row.vehicles) : " "),
      // },
      // { label: "Totals", value: "totals" },
    ];
  
    // if business is ACE, we need to add a row for Supercard to their report
    if (businessId === "lePLUdje4NIuHLUiWuow") {
      fields.splice(8, 0, { label: "Supercard", value: "supercard" });
    }
  
    return fields;
  };
  
  private generateVoidCheckInsReport = 
    async (data: {
      businessId?: any;
      endDate?: any;
      siteId?: any;
      startDate?: any;
    }) => {
        if (data.businessId) {
          const query = await this.generateQuery({
            businessId: data.businessId,
            endDate: data.endDate,
            siteId: data.siteId,
            startDate: data.startDate,
          });
  
          const checkIns = await this.getCheckIns(query);
          const processed = this.processCheckIns(checkIns);
  


          // console.log("GETTING TOTALS");
          // const optOutsTotal = await getOptOutsTotal(query);
          // const checkInsQuery = await query.get();
          // const checkInsTotal = checkInsQuery.size;
          // const voidedTotal = await getVoidedTotal(data);
  
          // // console.log(processed);
          // processed[0].totals = "Check Ins Count: " + checkInsTotal;
          // processed[1].totals = "Kiosk Opt Outs Count: " + optOutsTotal;
          // processed[2].totals = "Void Count: " + voidedTotal;
  
          const voidCsv =
            processed.length > 0
              ? parseCsv(processed, {
                  fields: this.generateFieldsArray(data.businessId),
                })
              : null;
  
          // console.log({
          //   checkIns: processed.length,
          //   data,
          //   timestamp: new Date().toString(),
          // });

          if (voidCsv) {
            return encodeURI(voidCsv);
          }else{
            return null;
          }
      }else{
        return null;
      }
    };

}

export default Reports;



// WEBPACK FOOTER //
// ./src/views/Reports.tsx